import { useTheme } from '../../theme/ThemeContext';
const SLOT_LINE_HEIGHT_PX = 20;
const SLOT_PADDING_BLOCK_PX = 8;
const SLOT_PADDING_INLINE_PX = 10;
const SLOT_BORDER_WIDTH_PX = 1;
const SLOT_MARGIN_BOTTOM_PX = 4;
const SLOT_ROW_GAP_PX = 8;
const SLOT_TOTAL_HEIGHT_PX = SLOT_LINE_HEIGHT_PX + SLOT_PADDING_BLOCK_PX * 2 + SLOT_BORDER_WIDTH_PX * 2 + SLOT_MARGIN_BOTTOM_PX;

// Reveal a sliver of the next row past the last fully-visible slot, so the list
// visibly signals that it scrolls rather than looking like a hard cutoff.
const PARTIAL_SLOT_PEEK_FRACTION = 1 / 3;
export const useSlotListStyles = () => {
  const theme = useTheme();
  const slotRowStyle = (isSelected, isDisabled) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: `${SLOT_ROW_GAP_PX}px`,
    padding: `${SLOT_PADDING_BLOCK_PX}px ${SLOT_PADDING_INLINE_PX}px`,
    lineHeight: `${SLOT_LINE_HEIGHT_PX}px`,
    borderRadius: theme.components.slotList.borderRadius,
    border: `${SLOT_BORDER_WIDTH_PX}px solid ${isSelected && !isDisabled ? theme.colors.primary : theme.colors.borderLight}`,
    background: theme.colors.background,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    marginBottom: `${SLOT_MARGIN_BOTTOM_PX}px`,
    fontSize: theme.fontSizes.md,
    fontWeight: isSelected && !isDisabled ? theme.fontWeights.bold : theme.fontWeights.normal,
    color: isSelected && !isDisabled ? theme.colors.primary : theme.colors.text,
    opacity: isDisabled ? 0.5 : 1
  });
  const scrollContainerStyle = maxVisibleSlots => ({
    maxHeight: SLOT_TOTAL_HEIGHT_PX * (maxVisibleSlots + PARTIAL_SLOT_PEEK_FRACTION),
    overflowY: 'auto'
  });
  return {
    slotRowStyle,
    scrollContainerStyle
  };
};